import { render, staticRenderFns } from "./device-modify.vue?vue&type=template&id=24334820&scoped=true"
import script from "./device-modify.vue?vue&type=script&lang=js"
export * from "./device-modify.vue?vue&type=script&lang=js"
import style0 from "./device-modify.vue?vue&type=style&index=0&id=24334820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24334820",
  null
  
)

export default component.exports